import { createAction } from "@reduxjs/toolkit";
import type { TrainingItemEvaluationVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const educationalAdvisorRetrieveEvaluationsByTrainingItem = createApiThunk<TrainingItemEvaluationVM[], string>(
  "evaluationsByTrainingItem/educationalAdvisorRetrieveEvaluationsByTrainingItem",
  async (studentId: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getEvaluationsByTrainingItem(studentId);
  },
);

export const resetEducationalAdvisorRetrieveEvaluationsByTrainingItem = createAction(
  "evaluationsByTrainingItem/resetEducationalAdvisorRetrieveEvaluationsByTrainingItem",
);
